import React, { useState, useEffect } from "react";
import { Autocomplete, Box, TextField, useTheme } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import { forcesColumns } from "./config";
import { dataGridStyles, localeText } from "../../utils/dataGridConfig";
import ErrorComponent from "../../components/ErrorComponent";
import { useGetForcesQuery } from "../../services/forceService";
import { useGetLotesQuery } from "../../services/loteService";

const Forces = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const navigate = useNavigate();

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  const [loteFilter, setLoteFilter] = useState("")
  const { data: lotes } = useGetLotesQuery({limit:100}, {
    refetchOnMountOrArgChange: true,
  });

  // Fetch data with pagination
  const { data: forces, error, isLoading, refetch } = useGetForcesQuery({
    offset: paginationModel.page * paginationModel.pageSize,
    limit: paginationModel.pageSize,
    lote_id: loteFilter
  });

  // Re-fetch data when paginationModel or searchTerm changes
  useEffect(() => {
    refetch();
  }, [paginationModel, refetch, loteFilter]); // Only depend on paginationModel and searchTerm

  const handleSeeApplications = async (force) => {
    console.log("force: ", force)
    navigate(`/applications?force_id=${force.id}&lote_id=${force.lote_id}`, '_blank', 'noopener,noreferrer');
  };

  const columns = forcesColumns(handleSeeApplications, colors);

  if (error) {
    return <ErrorComponent />;
  }

  return (
    <Box m="20px">
      <Header title="Forzas" subtitle="Lista de forzas" showCreateButton={false} />

      {/* Filter Section */}
      <Box
        display="grid"
        gap="30px"
        gridTemplateColumns="repeat(12, minmax(0, 1fr))"
      >
        {/* Lote Autocomplete */}
        <Autocomplete
          options={lotes?.records || []}
          getOptionLabel={(option) => option.name}
          value={
            lotes?.records.find((lote) => lote.id === loteFilter) || null
          }
          onChange={(event, value) => {
            setLoteFilter(value?.id);
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label="Lote"
              variant="outlined"
              size="small"
              fullWidth
            />
          )}
          sx={{ gridColumn: "span 2" }}
        />
      </Box>

      <Box sx={dataGridStyles(colors)} height="75vh">
        <DataGrid
          // Table Distribution
          columns={columns}
          rows={forces?.records || []}
          rowCount={forces?.count || 0}
          loading={isLoading}
          // Pagination
          pagination
          paginationModel={paginationModel}
          rowsPerPageOptions={[10, 20, 50]}
          pageSizeOptions={[10, 20, 50]}
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) => {
            setPaginationModel(newPaginationModel);
          }}
          // Custom Table
          loadingText="Cargando..."
          localeText={localeText}
          disableRowSelectionOnClick
          disableColumnMenu
          disableColumnSorting
        />
      </Box>
    </Box>
  );
};

export default Forces;